import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import { useLoading } from '../../../context/LoadingContext';
import { toWords } from "number-to-words";



function AMCDocument({adminData,companyID,branchID}) {
   
  const { setLoading } = useLoading();
     const [noteType, setNoteType] = useState(null);
  const [fetchData, setfetchData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [branchDetail, setBranchDetail] = useState([])
   const [showDownloadModal, setShowDownloadModal] = useState(false);
     const [selectedQuotation, setSelectedQuotation] = useState(null);
  const[company,setCompany] = useState([]);
const [showPDFModal, setShowPDFModal] = useState(false);


  
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  const reportOptions = [
      { value: 'amc_invoice', label: 'AMC Invoice' },
    { value: 'amc_quotation', label: 'AMC Quotation' },
  { value: 'service_card', label: 'Service Card' },


  ]


const numberToWords = (amount) => {
  if (!amount) return "";

  const num = Number(amount);
  if (isNaN(num)) return "";

  const words = toWords(num);

  return words
    .replace(/-/g, " ") 
    .split(" ")
    .filter(Boolean)
    .map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
};

    const fetchBranchDetail = async () => {
      setLoading(true)
    try {
      const resInventory = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
       setBranchDetail(resInventory.data)

    } catch (error) {
      console.log(error)
    } finally {
     setLoading(false);
        }
  };




    const fetchCompany = async () => {
      setLoading(true)
    try {
      const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
      setCompany(res.data);

    } catch (error) {
      console.log(error)
    } finally {
     setLoading(false);
        }
  };


   useEffect(() => {
  
      fetchBranchDetail();
      fetchCompany();
    }, []);



const handleSearch = async (e) => {
  e.preventDefault();



  try {
    const params = {
      note_type: noteType?.value,
      from_date:fromDate,
      to_date:toDate
    };



    const result = await axios.get(
      'https://api.skyguard.group/api/get-amc-document',
      { params }
    );

    const resultData = result?.data?.result || [];
     console.log('list',resultData);


    setfetchData(resultData);

 

    if (resultData.length > 0) {
      setToast('Report fetched successfully', 'success');
    } else {
      setToast('No data found in selected date range', 'warning');
    }

  } catch (error) {
    console.error('❌ Error fetching report:', error);
    setToast('Error fetching report. Please try again.', 'danger');
  }
};


  const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };

    const handleExportExcel = () => {
      const table = document.getElementById("exportTable");
    
      if (!table) return;
    
      const worksheet = XLSX.utils.table_to_sheet(table);
      const workbook = XLSX.utils.book_new();
    
      XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");
    
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
    
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
    
      saveAs(data, "Sale_Report.xlsx");
    };


    
const handlePrint = () => {
  const printContents = document.getElementById("invoice-print-area").innerHTML;
  const originalContents = document.body.innerHTML;

  // Open a new window for printing
  const printWindow = window.open("", "_blank", "width=900,height=600");
  printWindow.document.write(`
    <html>
      <head>
     
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { border-collapse: collapse; width: 100%; }
          table, th, td { border: 1px solid #000; }
          th, td { padding: 5px; text-align: center; }
          .text-start { text-align: left; }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};




const handleSaveMergedPDF = async () => {

  const pdf = new jsPDF("p", "mm", "a4");

  const pages = document.querySelectorAll(".pdf-page");

  for (let i = 0; i < pages.length; i++) {

    const canvas = await html2canvas(pages[i], {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");

    const imgWidth = 210;

    const imgHeight =
      (canvas.height * imgWidth) / canvas.width;

    if (i > 0) {
      pdf.addPage();
    }

    pdf.addImage(
      imgData,
      "PNG",
      0,
      0,
      imgWidth,
      imgHeight
    );
  }

  pdf.save("All_AMC_Bills.pdf");
};

const isServiceCard = noteType?.value === "service_card";

const th = {
  border: "1px solid #000",
  padding: "5px",
  fontSize: "12px",
  background: "#f2f2f2",
};

const td = {
  border: "1px solid #000",
  padding: "5px",
  fontSize: "12px",
};
  return (
      <div className='main-section'>
          <ToastNotification
            show={toast.show}
            message={toast.message}
            bg={toast.bg}
            onClose={() => setToast({ ...toast, show: false })}
          />
          <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
  
            <h3 className='my-3 fw-bold fs-5 golos'>AMC Documents</h3>
  
  
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className='fw-bold'>Select Document</label>
                <Select
                  options={reportOptions}
                  placeholder="Choose Type ..."
                  id="source"
                  value={noteType}
  
                  onChange={(selected) => {
                    setNoteType(selected);
                    setfetchData([]);
                  }}
                />
              </div>
  
              <div className="col-md-4">
                <label className='fw-bold'>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="from_date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
  
              <div className="col-md-4">
                <label className='fw-bold'>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="to_date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
  
  
              <div className="col-md-12 d-flex justify-content-end align-items-end">
                {/* <button className="btn btn-primary" onClick={handleSearch} >Search</button> */}
                 <FaSearch size={26} className="ms-1 text-primary"
                                style={{ cursor: "pointer" }}
                                title="Search"
                                onClick={handleSearch}
                              />
                
                              <MdLocalPrintshop
                                size={26}
                                className="ms-1 text-success me-1"
                                   onClick={handleExportExcel}
                                style={{ cursor: "pointer" }}
                                title="Print "
                              />
  
                            <button
    className='btn btn-warning'
    onClick={() => setShowPDFModal(true)}
  >
    Download PDF
  </button>
              </div>
            </div>
  
            <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
              {noteType?.value === 'amc_invoice' && (
                <table  className='table table-bordered table-striped table-hover text-center align-middle'>
                  <thead className='table-info'>
                    <tr>
                      <th>Doc No</th>
                      <th>Date</th>
                      <th>Party</th>
                      <th>Address</th>
                        <th>Item</th>
                        <th>Rate</th>
                        <th>Description</th>
                        <th>Added By</th>
                    
                    </tr>
                  </thead>
                  <tbody>
               {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
  
      let items = [];
      try {
        items = JSON.parse(item.items || "[]");
      } catch (e) {
        items = [];
      }
  
      return (
        <tr key={idx}>
  
          {/* Doc No */}
          <td>{`AMCI/${item.inv_no}/${item.branchId}`}</td>
  
          <td>{item.quotation_date}</td>
  
          <td>{item.party_name}</td>
  
          <td style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word" }}>{item.party_address}</td>
  
          {/* Item Details */}
          <td style={{ whiteSpace: "nowrap" }}>
            {items.map((it, i) => (
              <div key={i}>
                {it.name} (Qty: {it.qty})
              </div>
            ))}
          </td>
  
          {/* Rate */}
          <td>
            {items.map((it, i) => (
              <div key={i}>
                {it.rate}
              </div>
            ))}
          </td>
  
          {/* Remark - FIX WIDTH ISSUE */}
          <td style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word" }}>
            {item.remark}
          </td>
  
          <td>{item.emp_first || ""} {item.emp_middle || ""} {item.emp_last || ""}  </td>

  
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9">No data found</td>
    </tr>
  )}
                  </tbody>
                </table>
              )}
  
  {noteType?.value === 'amc_quotation' && (
                <table  className='table table-bordered table-striped table-hover text-center align-middle'>
                  <thead className='table-info'>
                    <tr>
                      <th>Doc No</th>
                      <th>Date</th>
                      <th>Party</th>
                      <th>Address</th>
                        <th>Item</th>
                        <th>Rate</th>
                        <th>Description</th>
                        <th>Added By</th>
                  
                    </tr>
                  </thead>
                  <tbody>
               {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
  
      let items = [];
      try {
        items = JSON.parse(item.items || "[]");
      } catch (e) {
        items = [];
      }
  
      return (
        <tr key={idx}>
  
          {/* Doc No */}
          <td>{`AMC/${item.inv_no}/${item.branchId}`}</td>
  
          <td>{item.quotation_date}</td>
  
          <td>{item.party_name}</td>
  
          <td style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word" }}>{item.party_address}</td>
  
          {/* Item Details */}
          <td style={{ whiteSpace: "nowrap" }}>
            {items.map((it, i) => (
              <div key={i}>
                {it.name} (Qty: {it.qty})
              </div>
            ))}
          </td>
  
          {/* Rate */}
          <td>
            {items.map((it, i) => (
              <div key={i}>
                {it.rate}
              </div>
            ))}
          </td>
  
          {/* Remark - FIX WIDTH ISSUE */}
          <td style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word" }}>
            {item.remark}
          </td>
  
          <td>{item.emp_first || ""} {item.emp_middle || ""} {item.emp_last || ""}  </td>
  
    
  
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9">No data found</td>
    </tr>
  )}
                  </tbody>
                </table>
              )}


    {noteType?.value === 'service_card' && (
                <table  className='table table-bordered table-striped table-hover text-center align-middle'>
                  <thead className='table-info'>
                    <tr>
                      <th>Doc No</th>
                      <th>Date</th>
                      <th>Party</th>
                      <th>Address</th>
                        <th>Item</th>
                        <th>Rate</th>
                        <th>Description</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
               {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
  
      let items = [];
      try {
        items = JSON.parse(item.items || "[]");
      } catch (e) {
        items = [];
      }
  
      return (
        <tr key={idx}>
  
          {/* Doc No */}
          <td>{`AMCI/${item.inv_no}/${item.branchId}`}</td>
  
          <td>{item.quotation_date}</td>
  
          <td>{item.party_name}</td>
  
          <td style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word" }}>{item.party_address}</td>
  
          {/* Item Details */}
          <td style={{ whiteSpace: "nowrap" }}>
            {items.map((it, i) => (
              <div key={i}>
                {it.name} (Qty: {it.qty})
              </div>
            ))}
          </td>
  
          {/* Rate */}
          <td>
            {items.map((it, i) => (
              <div key={i}>
                {it.rate}
              </div>
            ))}
          </td>
  
          {/* Remark - FIX WIDTH ISSUE */}
          <td style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word" }}>
            {item.remark}
          </td>
  
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9">No data found</td>
    </tr>
  )}
                  </tbody>
                </table>
              )}




                {noteType?.value === 'purchase_order' && (
                <table  className='table table-bordered table-striped table-hover text-center align-middle'>
                  <thead className='table-info'>
                    <tr>
                      <th>Doc No</th>
                      <th>Date</th>
                      <th>Party</th>
                      <th>Address</th>
                        <th>Item</th>
                        <th>Rate</th>
                        <th>Description</th>
                        <th>Added By</th>
                       
                    </tr>
                  </thead>
                  <tbody>
               {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
  
      let items = [];
      try {
        items = JSON.parse(item.items || "[]");
      } catch (e) {
        items = [];
      }
  
      return (
        <tr key={idx}>
  
          {/* Doc No */}
          <td>{`PO/${item.inv_no}/${item.branchId}`}</td>
  
          <td>{item.quotation_date}</td>
  
          <td>{item.party_name}</td>
  
          <td style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word" }}>{item.party_address}</td>
  
          {/* Item Details */}
          <td style={{ whiteSpace: "nowrap" }}>
            {items.map((it, i) => (
              <div key={i}>
                {it.name} (Qty: {it.qty})
              </div>
            ))}
          </td>
  
          {/* Rate */}
          <td>
            {items.map((it, i) => (
              <div key={i}>
                {it.rate}
              </div>
            ))}
          </td>
  
          {/* Remark - FIX WIDTH ISSUE */}
          <td style={{ maxWidth: "200px", whiteSpace: "normal", wordBreak: "break-word" }}>
            {item.remark}
          </td>
  
          <td>{item.emp_first || ""} {item.emp_middle || ""} {item.emp_last || ""}  </td>
  
  
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9">No data found</td>
    </tr>
  )}
                  </tbody>
                </table>
              )}

  
  
            </div>
  
  
  
  
  {showPDFModal && (
    <div
      className="position-fixed top-0 start-0 w-100 h-100"
      style={{
        background: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        overflowY: "auto",
        padding: "20px",
      }}
    >
  

  <div
    style={{
      width: "210mm",
      margin: "0 auto",
    }}
  >
  

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: "#fff",
        padding: "12px 20px",
        borderRadius: "8px",
        marginBottom: "10px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
  
  
      <h3
        style={{
          margin: 0,
          fontWeight: "700",
          color: "#222",
        }}
      >
        Preview All Bills
      </h3>
  
      <div
        style={{
          display: "flex",
          gap: "10px",
        }}
      >
  
        <button
          className="btn btn-success"
          onClick={handleSaveMergedPDF}
        >
          Save PDF
        </button>
  
        <button
          className="btn btn-danger"
          onClick={() => setShowPDFModal(false)}
        >
          Close
        </button>
  
      </div>
  
    </div>
  
  </div>
  
      <div id="all-bills-pdf">
  
        {fetchData.map((quotation, index) => {
   

          let parsedItems = [];
  
          try {
            parsedItems = JSON.parse(quotation.items || "[]");
          } catch {
            parsedItems = [];
          }
  
          let parsedAdditionalDetails = [];
  
          try {
            parsedAdditionalDetails = JSON.parse(
              quotation.additional_charges || "[]"
            );
          } catch {
            parsedAdditionalDetails = [];
          }
  

  
          const headerImageUrl =
            `https://api.skyguard.group/uploads/${branchDetail.header_img}`;
  
          return (

 <>
   
      {isServiceCard ? (
        <div
    key={index}
       className="pdf-page"
    style={{
      width: "210mm",
      minHeight: "297mm",
      margin: "10px auto",
      background: "#fff",
      padding: "10mm",
      fontSize: "13px",
      fontFamily: "Arial",
    }}
  >

    <h2 style={{ textAlign: "center", marginBottom: "0px" }}>
      {company.name}
    </h2>

    <h6 style={{ textAlign: "center", marginTop: "5px" }}>
      SERVICE CARD
    </h6>

  
    <div style={{ border: "1px solid #000", padding: "8px" }}>

      <div><b>Date:</b> {quotation.quotation_date}</div>
      <div><b>Party Name:</b> {quotation.party_name}</div>
      <div><b>Phone:</b> {quotation.party_phone}</div>
        <div><b>Start Date:</b> {quotation.start_date}</div>
          <div><b>End Date:</b> {quotation.end_date}</div>
    </div>


    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px",
      }}
    >
      <thead>
        <tr>
          <th style={th}>Sr</th>
          <th style={th}>Item</th>
          <th style={th}>Qty</th>
          <th style={th}>Serial No</th>
          <th style={th}>Installed At</th>
        </tr>
      </thead>

      <tbody>
        {parsedItems.map((item, i) => (
          <tr key={i}>
            <td style={td}>{i + 1}</td>
            <td style={td}>{item.name}</td>
            <td style={td}>{item.qty}</td>
            <td style={td}>
              {Array.isArray(item.sr_no)
                ? item.sr_no.join(", ")
                : item.sr_no}
            </td>
            <td style={td}>{item.install}</td>
          </tr>
        ))}
      </tbody>
    </table>


    <div style={{ marginTop: "15px" }}>
      <b>PMS Schedule</b>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "8px",
        }}
      >
        <thead>
          <tr>
            <th style={th}>PMS No </th>
            <th style={th}>Remarks</th>
            <th style={th}>Technician</th>
            <th style={th}>Customer Signature</th>
          </tr>
        </thead>

        <tbody>
          {(quotation.pms_ref_docs || "")
            .split(",")
            .filter(Boolean)
            .map((ref, i) => (
              <tr key={i}>
                <td style={td}>{ref}</td>
                <td style={td}></td>
                <td style={td}></td>
                <td style={td}></td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  </div>
      ) : (
    
         <div
              key={index}
              className="pdf-page"
              style={{
                width: "210mm",
                minHeight: "297mm",
                margin: "10px auto",
                background: "#fff",
                padding: "10mm",
                boxSizing: "border-box",
                pageBreakAfter: "always",
                position: "relative",
              }}
            >
  

              <img
                src={headerImageUrl}
                alt="watermark"
                style={{
                  position: "absolute",
                  top: "35%",
                  left: "50%",
                  width: "300px",
                  opacity: "0.1",
                  transform: "translate(-50%, -50%)",
                  zIndex: 0,
                }}
              />
  
              <div style={{ position: "relative", zIndex: 1 }}>
  
        
            <h3
  style={{
    textAlign: "center",
    marginBottom: "10px",
    fontWeight: "bold",
  }}
>
  {noteType?.value === "amc_invoice" && "AMC Invoice"}
  {noteType?.value === "amc_quotation" && "AMC Quotation"}
  {noteType?.value === "service_card" && "Service Card"}

</h3>


  
        
                <table className="invoice-table">
                  <tbody>
                    <tr>
  
                      <td style={{ width: "60%" }}>
                        <strong>{company.name}</strong><br />
  
                        {company.address}<br />
  
                        Phone: {company.phone}<br />
  
                        GSTIN: {company.gst}<br />
  
                        Email: {company.email}<br />
  
                        PAN: {company.pan}
                      </td>
  
                      <td style={{ width: "40%" }}>
  
                        <table className="invoice-table">
  
                          <tbody>
  
                            <tr>
                              <td>Date</td>
                              <td>{quotation.quotation_date}</td>
                            </tr>
  
                            <tr>
                              <td>Ref Doc</td>
  
                        
                              <td>
    {noteType?.value === "amc_invoice"
      ? "AMCI"
      : noteType?.value === "amc_quotation"
      ? "AMC"
      : noteType?.value === "service_card"
      ? "SC"
   
      : ""}
  /{quotation.inv_no}/{quotation.branchId}
  </td>
                            </tr>
  
                      </tbody>
  
                        </table>
  
                      </td>
  
                    </tr>
                  </tbody>
                </table>
  

                <table
                  className="invoice-table"
                  style={{ marginTop: "5px" }}
                >
                  <tbody>
  
                    <tr>
                      <td>
  
                        <strong>Party Details:</strong><br />
  
                        {quotation.party_name}<br />
  
                        {quotation.party_address}<br />
  
                        {quotation.party_city},
                        {quotation.party_state}<br />
  
                        Phone: {quotation.party_phone}<br />
  
                        Email: {quotation.party_email}
                      </td>
                    </tr>
  
                  </tbody>
                </table>
  
 
                <table
                  className="invoice-table"
                  style={{ marginTop: "5px" }}
                >
  
                  <thead>
  
                    <tr>
                      <th>Sr No</th>
                      <th>Description</th>
                      <th>Qty</th>
                      <th>Rate</th>
                      <th>Amount</th>
                    </tr>
  
                  </thead>
  
                  <tbody>
  
                    {parsedItems.map((item, i) => (
  
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.qty}</td>
                        <td>{item.rate}</td>
                        <td>{item.amount}</td>
                      </tr>
  
                    ))}
  
             
  
                    {Array.isArray(parsedAdditionalDetails) &&
    parsedAdditionalDetails.length > 0 && (
      <>
        <tr>
          <td colSpan="5" style={{ textAlign: "left", fontWeight: "bold" }}>
            Additional Charges
          </td>
        </tr>
  
        {parsedAdditionalDetails.map((row, i) => (
          <tr key={i}>
            <td colSpan="4" style={{ textAlign: "right" }}>
              {row.type}
            </td>
            <td style={{ textAlign: "right" }}>
              {Number(row.value2 || 0).toFixed(2)}
            </td>
          </tr>
        ))}
      </>
  )}
  
                    <tr>
                      <td colSpan="4" style={{ textAlign: "right" }}>
                        <strong>Total</strong>
                      </td>
  
                      <td>
                        <strong>{quotation.grand_total}</strong>
                      </td>
                    </tr>
  
                  </tbody>
  
                </table>
  
  
                <div
                  style={{
                    border: "1px solid #000",
                    padding: "5px",
                    marginTop: "5px",
                  }}
                >
                <strong>Amount Chargeable (In Words):</strong>{" "}
    {numberToWords(quotation.grand_total)} Rupees Only
  
             
                </div>
  
     
                <div
                  style={{
                    border: "1px solid #000",
                    height: "120px",
                    marginTop: "5px",
                    padding: "10px",
                    textAlign: "right",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <strong>Authorised Signatory</strong>
                </div>
  
   
                <div
                  style={{
                    border: "1px solid #000",
                    minHeight: "120px",
                    marginTop: "5px",
                    padding: "10px",
                  }}
                >
  
                  <strong>T & C :</strong>
  
                  {quotation.remark
                    ?.split(/(?=\d+\.)/)
                    .map((item, i) => (
                      <div key={i}>
                        {item.trim()}
                      </div>
                    ))}
  
                </div>
  
       
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "5px",
                    fontSize: "11px",
                  }}
                >
             This bill must be paid immediately and in case of delay interest at the rate of 20% per annum will be charged.  
We are not responsible for any delay or shortage etc. occuring in transit or from causes beyond our control.24% 
interest will be charged after 30days.
                </div>
  
              </div>
            </div>
      )}
    </>



          );
        })}
      </div>
  
      {/* CSS */}
      <style>
        {`
        .invoice-table {
          width: 100%;
          border-collapse: collapse;
        }
  
        .invoice-table td,
        .invoice-table th {
          border: 1px solid #000;
          padding: 5px;
          font-size: 12px;
        }
  
        @media print {
          .pdf-page {
            margin: 0;
            box-shadow: none;
          }
        }
        `}
      </style>
  
    </div>
  )}
  

          </div>
        </div>
  )
}

export default AMCDocument


